import React from 'react';
import { StructuredBriefFragment } from '@99designs/apps/spa/pages/create/briefs/DynamicBrief/DynamicBrief.generated';
import ContentSetting from '@99designs/apps/spa/pages/create/components/ContentSetting';
import SummaryCard from '@99designs/apps/spa/pages/create/components/summary/SummaryCard';
import SummaryCardItem from '@99designs/apps/spa/pages/create/components/summary/SummaryCardItem';
import { Field } from '@99designs/brief';
import { CurrencyCode } from '@99designs/i18n';
import { linkTo } from '@99designs/routing';

export function Summary({ brief }: { brief: StructuredBriefFragment }) {
    const { groups, dynamicFields, id, currency, category } = brief;

    const briefGroups = groups.map((g) => ({
        ...g,
        fields: dynamicFields.filter(
            (f) => f.groupId === g.id && Field.hasValue({ ...f, briefId: id })
        ),
    }));

    return (
        <ContentSetting>
            {briefGroups
                .filter((bg) => bg.fields.length > 0)
                .map((group, index) => (
                    <SummaryCard
                        key={group.id}
                        heading={group.title}
                        url={linkTo.brief(id, index + 1)}
                    >
                        {group.fields.map(
                            (field) =>
                                // Project briefs on 99designs do not currently support ClientConfiguredField nor
                                // WorkEntityField questions.
                                // At this point in time, such questions are only available for
                                // `libs/feature-design-services-brief`.
                                field.__typename !== 'ClientConfiguredField' &&
                                field.__typename !== 'WorkEntityField' && (
                                    <SummaryCardItem key={field.id} title={field.label}>
                                        <Field.View
                                            {...field}
                                            briefId={id}
                                            currency={currency as CurrencyCode}
                                            category={category}
                                        />
                                    </SummaryCardItem>
                                )
                        )}
                    </SummaryCard>
                ))}
        </ContentSetting>
    );
}
